import { selectPlaceData } from 'containers/MapDetails/placeSlice'
import usePlaceMapParams from './hooks/usePlaceMapParams'
import useTranslation from 'hooks/useTranslation'
import Legend from 'containers/Playground/Legend'
import Playground from 'containers/Playground'
import { useReduxSelector } from 'store'
import Summary from './Summary'
import React from 'react'

const playground = <Playground />
const legend = <Legend />

const Map: React.FC = () => {
  const params = usePlaceMapParams()
  const place = useReduxSelector(selectPlaceData)
  const { t } = useTranslation('placeMap')
  return (
    <div className='placeMap__container'>
      <div className='placeMap__playground'>
        <h2>{t('selectAWarehouseFromTheMap')}: {place.city}, {place.street} {place.estateNumber}{place.localNumber ? `/${place.localNumber}` : ''}</h2>
        {playground}
        {legend}
      </div>
      <div className={`placeMap__summary__wrapper${params.id ? '' : ' --hidden'}`}>
        <Summary />
      </div>
    </div>
  )
}

export default Map